// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import "swiper/css/bundle";
import Swiper from "swiper/bundle";

import lightGallery from "lightgallery";
import "lightgallery/css/lightgallery-bundle.min.css";

import lgThumbnail from "lightgallery/plugins/thumbnail";
import "lightgallery/css/lg-thumbnail.css";

//--------------------------------------------------------------------//

import "./carousel-gallery.scss";

const carouselGallery = () => {
    let allCarousel = document.querySelectorAll(".im-carousel-gallery");

    if (!allCarousel.length) return;

    allCarousel.forEach((el, i) => {
        let arrowPrev = el.querySelector(".swiper-button-prev");
        let arrowNext = el.querySelector(".swiper-button-next");

        let pagination = el.querySelector(".swiper-pagination");

        let typePagination = "bullets";

        if (pagination) {
            switch (true) {
                case pagination.classList.contains("bullets"):
                    typePagination = "bullets";
                    break;
                case pagination.classList.contains("fraction"):
                    typePagination = "fraction";
                    break;
                case pagination.classList.contains("progressbar"):
                    typePagination = "progressbar";
                    break;
                default:
                    typePagination = "bullets";
                    break;
            }
        }

        let args = {
            breakpoints: {
                0: {
                    spaceBetween: 24,
                    slidesPerView: 1.1,
                },

                1024: {
                    spaceBetween: 30,
                    slidesPerView: 1.2,
                },
            },
            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination: {
                el: pagination,
                clickable: true,
                type: typePagination,
                dynamicBullets: true,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                notificationClass: "swiper-notification",
            },
        };

        new Swiper(el.querySelector(".swiper-container"), args);

        lightGallery(el.querySelector(".lightgallery"), {
            thumbnail: true,
            plugins: [lgThumbnail],
            exThumbImage: "data-exthumbimage",
            animateThumb: true,
            mobileSettings: {
                showCloseIcon: true,
            },
            download: false,
            hideBarsDelay: 1000000000,
            autoplayControls: false,
            hash: false,
            escKey: true,
            keyPress: true,
            licenseKey: "WQ63Z-598QW-NZ7D5-WPMTB",
        });
    });
};

export default carouselGallery;
